module.exports = __webpack_public_path__ + "media/images/flags/32/Wales-3e3f3effd8a7a93e036b809b56b0aca8.png";